<template>
  <div class="member">
    <div class="title-box">订单管理</div>
    <div class="order-box noSelect">
      <div class="order-item" @click="jumpOrderStatus()">
        <p class="order-qty">{{order.total || 0}}</p>
        <p class="order-status">所有订单</p>
      </div>
      <div class="order-item" @click="jumpOrderStatus(0)">
        <p class="order-qty">{{order.total_0 || 0}}</p>
        <p class="order-status">待发货</p>
      </div>
      <div class="order-item" @click="jumpOrderStatus(1)">
        <p class="order-qty">{{order.total_3 || 0}}</p>
        <p class="order-status">发货中</p>
      </div>
      <div class="order-item" @click="jumpOrderStatus(2)">
        <p class="order-qty">{{order.total_4 || 0}}</p>
        <p class="order-status">发货完成</p>
      </div>
      <div class="order-item" @click="jumpOrderStatus(3)">
        <p class="order-qty">{{order.total_4 || 0}}</p>
        <p class="order-status">已退款</p>
      </div>
    </div>

    <div class="notice-main noSelect">
      <div class="notice-box-item">
        <div class="title-box">最新公告</div>
        <div class="notice-center">
          <div class="notice-item" v-for="item in noticeList" :key="item.id" @click="onJumpDetail(item.id, 14)">
            <span class="notice-item-title">{{item.title}}</span>
            <span class="notice-item-time">{{item.createtime}}</span>
          </div>
        </div>
      </div>
      <div class="notice-box-item">
        <div class="title-box">常见问题</div>
        <div class="notice-center">
          <div class="notice-item" v-for="item in newsList" :key="item.id" @click="onJumpDetail(item.id, 17)">
            <span class="notice-item-title">{{item.title}}</span>
            <span class="notice-item-time">{{item.createtime}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="advert-box" v-if="advert.bottom && advert.bottom.images"
         :style="`background-image: url('${API_URL + advert.bottom.images}')`"
         @click="onJumpPages(advert.bottom.link)"></div>

  </div>
</template>

<script>
import {apiUserOrderCount, apiNewsIndex} from "@/api/api"
export default {
  name: "member",
  data(){
    return{
      order: {},
      param: {
        limit: 5,
        page: 1,
      },
      noticeList: [],
      newsList: []
    }
  },
  computed: {
    advert() {
      let info = null;
      let advert = {}
      if (this.$store.getters.advert) {
        info = this.$store.getters.advert
      } else {
        info = localStorage.getItem("advertConfig");
        if (info) {
          info = JSON.parse(info);
        }
      }
      if(info){
        for (let i = 0; i < info.member.length; i++) {
          advert[info.member[i].key] = info.member[i];
        }
      }
      return advert;
    },
  },
  mounted(){
    this.loadData();
    //公告
    this.getNewsData(14);
    //常见问题
    this.getNewsData(17);
  },
  methods:{
    onJumpPages(url){
      if(url){
        this.$router.push(url);
      }
    },
    onJumpDetail(id, pid){
      this.$router.push("/news/detail?id="+id+"&type=help"+"&pid="+pid)
    },
    jumpOrderStatus(status){
      const url = (status || status === 0) ? "/order/lst?status="+status : "/order/lst"
      this.$router.push(url)
    },
    getNewsData(id){
      this.param.id = id;
      apiNewsIndex(this.param).then(res => {
        if(res.code === 1){
          var data = res.data.article_list.data;
          if(id === 17){
            this.newsList = data;
          }else{
            this.noticeList = data;
          }
        }

      })
    },
    loadData(){
      apiUserOrderCount().then(res => {
        if(res.code ===1 ){
          this.order = res.data;
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.member{
  .title-box{
    font-weight: bold;
    font-size: 16px;
    color: #0f375a;
    margin-bottom: 10px;
  }

  .order-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 50px;
    margin-top: 30px;

    .order-item{
      width: 140px;
      height: 140px;
      background-color: #0f375a;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;

      p{margin: 0;}

      .order-qty{
        font-size: 52px;
        font-weight: 400;
        color: #ffffff;
      }
      .order-status{
        font-weight: 400;
        color: #ffffff;
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }

  .advert-box{
    cursor: pointer;
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center center;
  }

  .notice-main{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .notice-box-item{
      width: 49%;

      .notice-center{
        border: 1px solid #E6E6E6;

        .notice-item{
          height: 40px;
          border-bottom: 1px solid #E6E6E6;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          cursor: pointer;

          &:hover .notice-item-title{
            font-weight: bold;
          }

          .notice-item-title{
            width: 180px;
            color: #000;
            font-size: 14px;
            overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
          }
          .notice-item-time{
            font-size: 14px;
            color: #999999;
          }

          &:last-child{
            border: none;
          }
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/user/components/member/index.vue